import { render, staticRenderFns } from "./CommunicationManagement.vue?vue&type=template&id=b1d9d8ea&scoped=true"
import script from "./CommunicationManagement.vue?vue&type=script&lang=js"
export * from "./CommunicationManagement.vue?vue&type=script&lang=js"
import style0 from "./CommunicationManagement.vue?vue&type=style&index=0&id=b1d9d8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d9d8ea",
  null
  
)

export default component.exports